import React from "react";
import {
  Box,
  Breadcrumbs,
  Link,
  Paper,
  Stack,
  Typography,
  ChevronRightIcon,
  StarIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

function handleClick(event) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

const BasicBreadcrumbWithIcon = () => {
  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      href="/"
      onClick={handleClick}
    >
      <Stack direction={"row"} alignItems="center" spacing={0.5}>
        <StarIcon fontSize="inherit" />
        <Typography variant="body1">Link</Typography>
      </Stack>
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      href="#"
      onClick={handleClick}
    >
      <Stack direction={"row"} alignItems="center" spacing={0.5}>
        <StarIcon fontSize="inherit" />
        <Typography variant="body1">Link</Typography>
      </Stack>
    </Link>,
    <Typography key="3" color="text.primary">
      <Stack direction={"row"} alignItems="center" spacing={0.5}>
        <StarIcon fontSize="inherit" />
        <Typography variant="body1">Link</Typography>
      </Stack>
    </Typography>,
  ];

  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Breadcrumbs with icons
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <Typography variant="body1" fontSize={14}>
            Basic breadcrumbs With Icon
          </Typography>

          <Box mb={3}>
            <PreviewAndEditor
              language={"js"}
              value={
                '<Breadcrumbs aria-label="breadcrumb">\n' +
                "                  <Link\n" +
                '                    underline="hover"\n' +
                '                    sx={{ display: "flex", alignItems: "center" }}\n' +
                '                    color="inherit"\n' +
                '                    href="/#"\n' +
                "                  >\n" +
                '                    <Stack direction={"row"} alignItems="center" spacing={0.5}>\n' +
                '                      <StarIcon fontSize="inherit" />\n' +
                '                      <Typography variant="body1">Link</Typography>\n' +
                "                    </Stack>\n" +
                "                  </Link>\n" +
                "                  <Link\n" +
                '                    underline="hover"\n' +
                '                    sx={{ display: "flex", alignItems: "center" }}\n' +
                '                    color="inherit"\n' +
                '                    href="/#"\n' +
                "                  >\n" +
                '                    <Stack direction={"row"} alignItems="center" spacing={0.5}>\n' +
                '                      <StarIcon fontSize="inherit" />\n' +
                '                      <Typography variant="body1">Link</Typography>\n' +
                "                    </Stack>\n" +
                "                  </Link>\n" +
                "                  <Typography\n" +
                '                    sx={{ display: "flex", alignItems: "center" }}\n' +
                '                    color="text.primary"\n' +
                "                  >\n" +
                '                    <Stack direction={"row"} alignItems="center" spacing={0.5}>\n' +
                '                      <StarIcon fontSize="inherit" />\n' +
                '                      <Typography variant="body1">Link</Typography>\n' +
                "                    </Stack>\n" +
                "                  </Typography>\n" +
                "                </Breadcrumbs>"
              }
            >
              <div role="presentation" onClick={handleClick}>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link
                    underline="hover"
                    sx={{ display: "flex", alignItems: "center" }}
                    color="inherit"
                    href="/#"
                  >
                    <Stack direction={"row"} alignItems="center" spacing={0.5}>
                      <StarIcon fontSize="inherit" />
                      <Typography variant="body1">Link</Typography>
                    </Stack>
                  </Link>
                  <Link
                    underline="hover"
                    sx={{ display: "flex", alignItems: "center" }}
                    color="inherit"
                    href="/#"
                  >
                    <Stack direction={"row"} alignItems="center" spacing={0.5}>
                      <StarIcon fontSize="inherit" />
                      <Typography variant="body1">Link</Typography>
                    </Stack>
                  </Link>
                  <Typography
                    sx={{ display: "flex", alignItems: "center" }}
                    color="text.primary"
                  >
                    <Stack direction={"row"} alignItems="center" spacing={0.5}>
                      <StarIcon fontSize="inherit" />
                      <Typography variant="body1">Link</Typography>
                    </Stack>
                  </Typography>
                </Breadcrumbs>
              </div>
            </PreviewAndEditor>
          </Box>

          <Box mb={2}>
            <Typography variant="body1" fontSize={14}>
              Basic breadcrumbs with Custom separator and Icon
            </Typography>

            <PreviewAndEditor

              language={"js"}
              value={
                "  const breadcrumbs = [\n" +
                "    <Link\n" +
                '      underline="hover"\n' +
                '      key="1"\n' +
                '      color="inherit"\n' +
                '      href="/"\n' +
                "      onClick={handleClick}\n" +
                "    >\n" +
                '      <Stack direction="row" alignItems="center" spacing={0.5}>\n' +
                '        <StarIcon fontSize="inherit" />\n' +
                '        <Typography variant="body1">Link</Typography>\n' +
                "      </Stack>\n" +
                "    </Link>,\n" +
                "    <Link\n" +
                '      underline="hover"\n' +
                '      key="2"\n' +
                '      color="inherit"\n' +
                '      href="#"\n' +
                "      onClick={handleClick}\n" +
                "    >\n" +
                '      <Stack direction="row" alignItems="center" spacing={0.5}>\n' +
                '        <StarIcon fontSize="inherit" />\n' +
                '        <Typography variant="body1">Link</Typography>\n' +
                "      </Stack>\n" +
                "    </Link>,\n" +
                '    <Typography key="3" color="text.primary">\n' +
                '      <Stack direction="row" alignItems="center" spacing={0.5}>\n' +
                '        <StarIcon fontSize="inherit" />\n' +
                '        <Typography variant="body1">Link</Typography>\n' +
                "      </Stack>\n" +
                "    </Typography>,\n" +
                "  ];\n" +
                "                <Breadcrumbs\n" +
                '                  separator={<NavigateNextIcon fontSize="small" />}\n' +
                '                  aria-label="breadcrumb"\n' +
                "                >\n" +
                "                  {breadcrumbs}\n" +
                "                </Breadcrumbs>"
              }
            >
              <Stack direction={"row"} spacing={2}>
                <Breadcrumbs
                  separator={<ChevronRightIcon fontSize="small" />}
                  aria-label="breadcrumb"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Stack>
            </PreviewAndEditor>
          </Box>

          <Typography variant="body1" fontSize={14}>
            Basic breadcrumbs with Custom separator and Icon
          </Typography>

          <PreviewAndEditor

            language={"js"}
            value={
              "  const breadcrumbs = [\n" +
              "    <Link\n" +
              '      underline="hover"\n' +
              '      key="1"\n' +
              '      color="inherit"\n' +
              '      href="/"\n' +
              "      onClick={handleClick}\n" +
              "    >\n" +
              '      <Stack direction="row" alignItems="center" spacing={0.5}>\n' +
              '        <StarIcon fontSize="inherit" />\n' +
              '        <Typography variant="body1">Link</Typography>\n' +
              "      </Stack>\n" +
              "    </Link>,\n" +
              "    <Link\n" +
              '      underline="hover"\n' +
              '      key="2"\n' +
              '      color="inherit"\n' +
              '      href="#"\n' +
              "      onClick={handleClick}\n" +
              "    >\n" +
              '      <Stack direction="row" alignItems="center" spacing={0.5}>\n' +
              '        <StarIcon fontSize="inherit" />\n' +
              '        <Typography variant="body1">Link</Typography>\n' +
              "      </Stack>\n" +
              "    </Link>,\n" +
              '    <Typography key="3" color="text.primary">\n' +
              '      <Stack direction="row" alignItems="center" spacing={0.5}>\n' +
              '        <StarIcon fontSize="inherit" />\n' +
              '        <Typography variant="body1">Link</Typography>\n' +
              "      </Stack>\n" +
              "    </Typography>,\n" +
              "  ];\n" +
              "              <Breadcrumbs\n" +
              '                separator={<NavigateNextIcon fontSize="small" />}\n' +
              '                aria-label="breadcrumb"\n' +
              "                maxItems={2}\n" +
              "              >\n" +
              "                {breadcrumbs}\n" +
              "              </Breadcrumbs>"
            }
          >
            <Stack direction={"row"} spacing={2}>
              <Breadcrumbs
                separator={<ChevronRightIcon fontSize="small" />}
                aria-label="breadcrumb"
                maxItems={2}
              >
                {breadcrumbs}
              </Breadcrumbs>
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default BasicBreadcrumbWithIcon;
